import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {EmailSentViewComponent} from './email-sent-view.component';
import {ViewByIdDefaultModule} from '../../../../../core/component/view-by-id-default/view-by-id-default.module';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {DatetimeLabelModule} from '../../../../../core/component/date/datetime-label/datetime-label.module';
import {
    WorkflowTaskStatusLabelModule
} from '../../../../../workflow/task/api/component/workflow-task-status-label/workflow-task-status-label.module';
import {CardModule} from '../../../../../core/component/card/card.module';
import {
    EmailSummaryFieldModule
} from '../../../../../common/email/component/email-summary-field/email-summary-field.module';
import {SummaryFieldModule} from '../../../../../core/component/summary-field/summary-field.module';
import {KeepHtmlPipeModule} from '../../../../../core/pipe/keep-html.pipe';
import {
    DatetimeSummaryFieldModule
} from '../../../../../core/component/date/datetime-summary-field/datetime-summary-field.module';
import {DialogModule} from '../../../../../common/dialog/dialog.module';
import {
    DocumentSummaryFieldByIdComponent
} from "../../../../../document/common/api/component/document-summary-field-by-id/document-summary-field-by-id.component";
import {
    PartnerSummaryFieldModule
} from "../../../../../partner/common/api/component/partner-summary-field/partner-summary-field.module";
import {CardV2Component} from "../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ViewByIdDefaultModule,
        FormFieldModule,
        DatetimeLabelModule,
        WorkflowTaskStatusLabelModule,
        CardModule,
        EmailSummaryFieldModule,
        SummaryFieldModule,
        KeepHtmlPipeModule,
        DatetimeSummaryFieldModule,
        DialogModule,
        DocumentSummaryFieldByIdComponent,
        PartnerSummaryFieldModule,
        CardV2Component
    ],
    declarations: [EmailSentViewComponent]
})
export class EmailSentViewModule {
}
